<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="promotionDialog = true"
      v-if="!isEditPromotion"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <promotionForm
      :selected_item="selected_item"
      :dialog="promotionDialog"
      @setDialog="promotionDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
    />
    <v-layout row wrap class="px-3">
      <v-flex xs12 sm8>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search code / name"
          single-line
          hide-details
        >
        </v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm3>
        <v-select
          :items="[
            { name: 'All Service', value: -1 },
            { name: 'Food delivery', value: 1 },
            { name: 'Messenger', value: 2 },
          ]"
          item-text="name"
          item-value="value"
          single-line
          hide-details
          prepend-icon="filter_alt"
          v-model="filterOrderType"
        ></v-select>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <div style="display: flex; justify-content: flex-end" class="py-1 mr-5">
      <download-excel
        :data="filteredPromotionList"
        :fields="{
          'Order type': {
            field: 'promotion_order_type',
            callback: (value) => {
              return value == 1
                ? 'Food delivery'
                : value == 2
                ? 'Messenger'
                : value == 3
                ? 'Free'
                : '';
            },
          },
          Code: 'promotion_code',
          Name: 'promotion_name_th',
          Type: {
            field: 'promotion_type',
            callback: (value) => {
              if (value == 1) {
                return 'Product';
              } else if (value == 2) {
                return 'Transfer';
              } else if (value == 3) {
                return 'Product and transfer';
              }
              return '';
            },
          },
          Discount: 'promotion_discount',
          Unit: {
            field: 'promotion_unit',
            callback: (value) => {
              if (value == 1) {
                return '฿';
              } else if (value == 2) {
                return '%';
              }
              return '';
            },
          },
          Used: 'promotion_use',
          Total: 'promotion_amount',
          Start: 'promotion_start_date',
          End: 'promotion_end_date',
        }"
        :name="'Promotion-list.xls'"
        style="margin-right: 50px"
      >
        <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
      </download-excel>

      <download-excel
        type="csv"
        :data="filteredPromotionList"
        :fields="{
          'Order type': {
            field: 'promotion_order_type',
            callback: (value) => {
              return value == 1
                ? 'Food delivery'
                : value == 2
                ? 'Messenger'
                : value == 3
                ? 'Free'
                : '';
            },
          },
          Code: 'promotion_code',
          Name: 'promotion_name_th',
          Type: {
            field: 'promotion_type',
            callback: (value) => {
              if (value == 1) {
                return 'Product';
              } else if (value == 2) {
                return 'Transfer';
              } else if (value == 3) {
                return 'Product and transfer';
              }
              return '';
            },
          },
          Discount: 'promotion_discount',
          Unit: {
            field: 'promotion_unit',
            callback: (value) => {
              if (value == 1) {
                return '฿';
              } else if (value == 2) {
                return '%';
              }
              return '';
            },
          },
          Used: 'promotion_use',
          Total: 'promotion_amount',
          Start: 'promotion_start_date',
          End: 'promotion_end_date',
        }"
        :name="'Promotion-list.csv'"
      >
        <v-btn icon>
          <v-icon large color="black">print</v-icon> <span>.csv</span>
        </v-btn>
      </download-excel>
    </div>
    <v-data-table
      :headers="headers"
      :items="filteredPromotionList"
      :pagination.sync="pagination"
      :loading="loading_message"
      :rows-per-page-items="[25, 50, 100, 500, 1000, 2000]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ promotion_list.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-left">{{ showOrderType(props.item) }}</td>
        <td class="text-xs-left">{{ props.item.promotion_code }}</td>
        <td class="text-xs-left">{{ props.item.promotion_name_th }}</td>
        <td class="text-xs-left">{{ filterPromoType(props.item) }}</td>
        <td class="text-xs-right">
          {{
            props.item.promotion_discount + " " + filterPromoUnit(props.item)
          }}
        </td>
        <td class="text-xs-right">
          {{ props.item.promotion_use + " / " + props.item.promotion_amount }}
        </td>
        <td class="text-xs-center">{{ props.item.promotion_start_date }}</td>
        <td class="text-xs-center">{{ props.item.promotion_end_date }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                $store.state.backOffice.province +
                '/food/' +
                props.item.promotion_id +
                '/promotionlog'
              "
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View log</span>
          </v-tooltip>
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon @click="editPromotion(props.item)" slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              @click="deletePromotion(props.item)"
              v-if="!isEditPromotion"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import promotionForm from "./PromotionForm";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    loading_message: false,
    filterOrderType: -1,
    selected_item: {},
    search: "",
    promotionDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 25,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Order type",
        align: "center",
        value: "promotion_order_type_name_temp",
        sortable: false,
      },
      {
        text: "Code",
        align: "center",
        value: "promotion_code",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        value: "promotion_name_th",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "promotion_type_name_temp",
        sortable: false,
      },
      {
        text: "Discount",
        align: "center",
        value: "promotion_discount",
        sortable: false,
      },
      {
        text: "Used / Total",
        align: "center",
        value: "promotion_amount",
        sortable: false,
      },
      {
        text: "Start",
        align: "center",
        value: "promotion_start_date",
        sortable: false,
      },
      {
        text: "End",
        align: "center",
        value: "promotion_end_date",
        sortable: false,
      },
      {
        text: "Log",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
  }),
  components: {
    promotionForm,
  },
  computed: {
    ...mapState({
      promotion_list: (state) => state.fetchFoodPromotionBack.promotion_list,
    }),
    ...mapGetters({
      isEditPromotion: "isEditPromotion",
    }),
    pages() {
      this.pagination.totalItems = this.promotion_list.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filteredPromotionList() {
      return this.promotion_list.filter(
        (element) =>
          (element.promotion_code
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
            element.promotion_name_th
              .toLowerCase()
              .includes(this.search.toLowerCase())) &&
          (this.filterOrderType == element.promotion_order_type ||
            this.filterOrderType == -1)
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    filterPromoUnit(item) {
      if (item.promotion_unit == 1) {
        return "฿";
      } else if (item.promotion_unit == 2) {
        return "%";
      }
      return "";
    },
    filterPromoType(item) {
      if (item.promotion_type == 1) {
        return "Product";
      } else if (item.promotion_type == 2) {
        return "Transfer";
      } else if (item.promotion_type == 3) {
        return "Product and transfer";
      }
      return "";
    },
    showOrderType(item) {
      if (item.promotion_order_type == 1) {
        return "Food";
      } else if (item.promotion_order_type == 2) {
        return "Messenger";
      } else if (item.promotion_order_type == 3) {
        return "Free";
      }
      return "";
    },
    async deletePromotion(item) {
      let check = confirm("Do you want to delete this promotion ?");
      if (check == true) {
        await this.$store.dispatch(
          "fetchFoodPromotionBack/deletePromotionDetail",
          {
            promotion_id: item.promotion_id,
            province: this.$route.params.province,
          }
        );
      }
    },
    async initialize() {
      this.loading_message = true;
      await this.$store.dispatch(
        "fetchFoodPromotionBack/getPromotionList",
        this.$route.params.province
      );
      this.loading_message = false;
    },
    editPromotion(item) {
      this.selected_item = item;
      this.promotionDialog = true;
      this.editedIndex = 1;
    },
  },
};
</script>

